<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div
                    v-if="doctorMenus !== null"
                    class="pt-3">
                    <div class="d-flex justify-content-end">
                        <b-button
                            variant="yokumiru-orange"
                            @click="showModalAdminAddDoctorMenu">
                            {{ $locale.consultation_host }}メニュー追加
                        </b-button>
                    </div>
                    <div
                        v-for="medicalCourse in doctor.medical_courses"
                        class="mb-3">
                        <h4 class="ml-3 mb-0 headingDoctorMenuMedicalCourse">
                            {{ medicalCourse.name }}
                        </h4>
                        <template v-if="medicalCourse.menus.length > 0">
                            <template v-for="menu in medicalCourse.menus">
                                <admin-doctor-menu :menu="menu"/>
                            </template>
                        </template>
                        <template v-else>
                            <p class="text-muted ml-3 pt-2 pb-3">
                                この{{ $locale.consultation_host }}科にはまだメニューがありません。
                            </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <admin-add-doctor-menu-modal :doctor="doctor"/>
        <admin-edit-doctor-menu-modal/>
        <admin-delete-doctor-menu-modal/>
        <admin-toggle-status-doctor-menu-modal/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'

    export default {
        props: {
            doctor: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                doctorMenus: null,
            }
        },

        created: function () {
            this.fetchDoctorMenus()
            bus.$on('fetch-doctor-menus', this.fetchDoctorMenus)
        },

        beforeDestroy: function () {
            bus.$off('fetch-doctor-menus')
        },

        methods: {
            /**
             * 医師メニュー一覧取得
             */
            fetchDoctorMenus: async function () {
                if (this.inProgress) return
                this.inProgress = true
                this.doctorMenus = null

                await axios.get(`${constants.admin.doctors.endpoint.base}/${this.doctor.id}/doctor_menus`)
                    .then(({data}) => {
                        this.doctorMenus = data.data
                        this.makeGroupDoctorMenus()
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },

            /**
             * 医師メニューを相談科毎にグルーピング
             */
            makeGroupDoctorMenus: function () {
                this.doctor.medical_courses.forEach((medicalCourse) => {
                    medicalCourse.menus = []
                    this.doctorMenus.forEach((menu) => {
                        if (medicalCourse.id === menu.medical_course_id) {
                            medicalCourse.menus.push(menu)
                        }
                    } )
                })
            },

            /**
             * 相談メニュー追加モーダル表示
             */
            showModalAdminAddDoctorMenu: function () {
                bus.$emit('open-modal-admin-add-doctor-menu')
            },
        },
    };
</script>

<style lang="scss" scoped>
.headingDoctorMenuMedicalCourse {
    color: #2A2E31;

    &::before {
        content: "";
        position: relative;
        top: 2px;
        display: inline-block;
        width: 10px;
        height: 20px;
        border-left: 5px solid #536EA1;
        padding-right: 5px;
    }
}
</style>
